import React from 'react';

import { Wrapper, Inner, Suggestions } from './styles';

type Props = {
  children: React.ReactNode;
  containerRef: React.Ref<HTMLUListElement>;
};

export const SuggestionBox = (props: Props) => {
  const { children, containerRef } = props;

  return (
    <Wrapper>
      <Inner>
        <Suggestions ref={containerRef}>{children}</Suggestions>
      </Inner>
    </Wrapper>
  );
};
